<template>
  <div class="defective-box">
    <el-tabs v-model="tabName" @tab-click="handleTab">
      <el-tab-pane label="分播日志" name="cut-log"></el-tab-pane>
      <el-tab-pane
        label="无数据id分播日志"
        name="no-data-cut-log"
      ></el-tab-pane>
    </el-tabs>

    <div v-if="tabName == 'cut-log'">
      <CutLog :stock-store-list="stockStoreList"></CutLog>
    </div>
    <div v-if="tabName == 'no-data-cut-log'">
      <NoDataCutLog :stock-store-list="stockStoreList"></NoDataCutLog>
    </div>
  </div>
</template>

<script>
import CutLog from "./components/CutLog.vue";
import NoDataCutLog from "./components/NoDataCutLog.vue";
import { postListStockStorehouseConfig } from "@/openapi/erp/stockStorehouse.js";

export default {
  components: {
    CutLog,
    NoDataCutLog,
  },
  data() {
    return {
      loading: false,
      tabName: "cut-log",
      stockStoreList: [],
    };
  },
  created() {
    // 获取仓库列表
    this.getListStockStorehouseConfig();
  },
  methods: {
    handleTab(tab) {
      this.tabName = tab.name;
    },
    getListStockStorehouseConfig() {
      postListStockStorehouseConfig({ is_pc: "1" }).then((res) => {
        this.stockStoreList = res;
      });
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/devicecut/index.vue